import React from "react";
import Chip from '@material-ui/core/Chip/Chip';

import withStyles from "@material-ui/core/styles/withStyles";

const styles = theme => ({

  label: {
    color: 'black',
  },

});

const releaseStatusColors = {
  VALIDATION: '#c7c7c7',
  WITHDRAWN: '#ff7975',
  IN_PRODUCTION: '#6dde69',
}


const StatusComponent = ({ releaseStatus, classes }) => {

  const inlineStyle = {
    background: releaseStatusColors[releaseStatus]
  }

  return <Chip label={releaseStatus} style={inlineStyle} classes={{ label: classes.label }} />

};
export default withStyles(styles)(StatusComponent);
